import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@jsverse/transloco';
import { DialogActions } from 'src/app/model/dictionary';
import { getDialogConfig } from 'src/app/util/dialog-util';
import { UserApiService } from 'src/app/data-transfer/services/user-api-service';
import { FileApiService } from 'src/app/data-transfer/services/file-api-service';
import { CeoDto } from 'src/app/data-transfer/entities/doc-entities/ceo-dto';
import { SigneeDto } from 'src/app/data-transfer/entities/doc-entities/signee-dto';
import { SignatureCaptureDialogComponent, SignatureCaptureDialogData } from '../signature-capture-dialog/signature-capture-dialog.component';

export class CreateDocSignatureDialogData {
  constructor(
    public person: CeoDto | SigneeDto,
    public isCeo: boolean
  ) {}
}

@Component({
  selector: 'app-create-doc-signature-dialog',
  templateUrl: './create-doc-signature-dialog.component.html',
  styleUrls: ['./create-doc-signature-dialog.component.scss'],
})
export class CreateDocSignatureDialogComponent {
  withSignature = false;
  isSaving = false;

  constructor(
    private dialogRef: MatDialogRef<CreateDocSignatureDialogComponent>,
    private dialog: MatDialog,
    private userApiService: UserApiService,
    private fileApiService: FileApiService,
    private translocoService: TranslocoService,
    @Inject(MAT_DIALOG_DATA) public data: CreateDocSignatureDialogData
  ) {}

  selectOption(withSignature: boolean): void {
    this.withSignature = withSignature;
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onCreate(): void {
    if (this.isSaving) {
      return;
    }

    if (!this.withSignature) {
      this.dialogRef.close({ confirmed: true, addSignatureImage: false, signatureImage: null });
      return;
    }

    if (this.data.person.signatureImageId) {
      this.dialogRef.close({ confirmed: true, addSignatureImage: true, signatureImage: null });
      return;
    }

    const dialogData = new SignatureCaptureDialogData(
      `${this.data.person.firstName} ${this.data.person.lastName}`,
      null,
      true,
      this.translocoService.translate('createDoc.signatureDialog.createButton')
    );
    this.dialog
      .open(SignatureCaptureDialogComponent, getDialogConfig(dialogData, '680px'))
      .afterClosed()
      .subscribe(result => {
        if (result?.event !== DialogActions.CONFIRM) return;
        if (!result.data.signatureImageId) {
          this.dialogRef.close({ confirmed: true, addSignatureImage: true, signatureImage: result.data.signatureImage });
          return;
        }

        this.isSaving = true;
        const request = this.data.isCeo
          ? this.userApiService.createOrUpdateCeoProfiles([{ ...this.data.person, signatureImageId: result.data.signatureImageId }], true)
          : this.userApiService.createOrUpdateSigneeProfiles([{ ...this.data.person, signatureImageId: result.data.signatureImageId } as SigneeDto], true);
        request.subscribe({
          next: () => {
            this.isSaving = false;
            this.dialogRef.close({ confirmed: true, addSignatureImage: true, signatureImage: null });
          },
          error: () => {
            this.isSaving = false;
            this.fileApiService.getImageById(result.data.signatureImageId).subscribe(blob => {
              this.dialogRef.close({ confirmed: true, addSignatureImage: true, signatureImage: blob });
            });
          },
        });
      });
  }
}
